import MainJson from '../resources/main.json';

class JsonManager {
  static getSearch() {
    return MainJson.search;
  }

  static getAbout() {
    return MainJson.about;
  }

  static getContact() {
    return MainJson.contact;
  }

  static getHeader() {
    return MainJson.header;
  }

  static getImagesPath(type) {
    return MainJson.images_paths[type];
  }

  static getAllProjects() {
    return MainJson.projects;
  }

  static getProject(id) {
    if (id) {
      return MainJson.projects[id];
    }
    return MainJson.projects[this.id];
  }

  static getSection(id) {
    if (id) {
      return MainJson.sections[id];
    }
    return MainJson.sections[this.id];
  }

  static getSVG(id) {
    return MainJson.combined_svgs[id];
  }

  static getIcon(id) {
    return MainJson.images[id];
  }

  static getBanners(id) {
    return MainJson.banners[id];
  }

  static getArticle(id) {
    return MainJson.article[id];
  }

  static getLink(id) {
    return MainJson.links[id];
  }

  static getCopyright() {
    return MainJson.copyright;
  }
}

export default JsonManager;



// WEBPACK FOOTER //
// ./src/managers/JsonManager.js